export default __webpack_public_path__ + "static/media/2469.1555d2cd.png";